<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="onboarding-header">
          <div class="progress-indicator mb-3">
            <span style="width: 25%"></span>
          </div>
          <p class="mt-0 mb-1 ion-text-uppercase dark text-sm">Passo 1 de 4</p>
          <p class="mt-0 mb-0 white text-xxl ion-text-uppercase">Meu objetivo</p>
        </div>
        <div class="onboarding-row-pt pb-4">
          <label class="dark bold">Qual o seu objetivo principal com a dieta?</label>
          <div class="mb-2 mt-3" @click="selectGoal('loseWeight')">
            <div :class="loseWeight.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Emagrecimento</p>
              <p class="mt-0 mb-0 text-left text-sm thin dark">
                Dieta
                <span class="bold green">Low Carb</span> para perda de gordura
              </p>
            </div>
          </div>
          <div class="mb-2" @click="selectGoal('gainMuscles')">
            <div :class="gainMuscles.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Hipertrofia</p>
              <p class="mt-0 mb-0 text-left text-sm thin dark">Dieta para ganho de massa muscular</p>
            </div>
          </div>
          <div class="mb-5" @click="selectGoal('stayHealthy')">
            <div :class="stayHealthy.class">
              <p class="mt-0 pseudo-button-p-margin-bottom text-left text-md bold">Equilíbrio</p>
              <p class="mt-0 mb-0 text-left text-sm thin dark">Dieta balanceada para se manter bem</p>
            </div>
          </div>
          <ion-button
            v-if="nextButtonColor === 'primary'"
            shape="round"
            expand="block"
            mode="ios"
            class="bottom-button"
            :color="nextButtonColor"
            @click="gotoNext"
          >
            <ion-icon mode="ios" name="arrow-forward" class="white"></ion-icon>
          </ion-button>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "OnboardingGoal",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      goal: null,
      nextButtonColor: "white",
      loseWeight: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      },
      gainMuscles: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      },
      stayHealthy: {
        selected: false,
        class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    selectGoal(goal) {
      this.goal = goal;
      this.nextButtonColor = "primary";
      if (goal === "loseWeight") {
        this.loseWeight = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
      } else if (goal === "gainMuscles") {
        this.loseWeight = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
      } else {
        this.loseWeight = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.gainMuscles = {
          selected: false,
          class: "pseudo-button pt-3 pb-3 pl-3 pr-3"
        };
        this.stayHealthy = {
          selected: true,
          class: "pseudo-button pseudo-button-selected pt-3 pb-3 pl-3 pr-3"
        };
      }
    },
    gotoNext() {
      const instance = this;
      instance.startLoading();
      const goal = instance.goal;
      if (goal) {
        let ref = db
          .collection("users")
          .where("userId", "==", instance.user.uid);
        ref.get().then(snapshot => {
          snapshot.forEach(doc => {
            db.collection("users")
              .doc(doc.id)
              .update({
                goal: goal
              })
              .then(() => {
                instance.profile.data.goal = goal;
                store.updateProfile(instance.profile);
                instance.isLoading = false;
                instance.$router.push({
                  name: "Onboarding: Body"
                });
              })
              .catch(error => {
                instance.isLoading = false;
                instance.notification = {
                  class: "error-message p-3",
                  message:
                    "Ocorreu um erro ao processar essa operação. Tente novamente."
                };
                setTimeout(() => {
                  instance.clearNotification();
                }, 3000);
              });
          });
        });
      } else {
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message: "Selecione um objetivo para continuar."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    try {
      instance.user = store.state.user;
      instance.profile = store.state.profile;
      if (instance.profile.data.goal) {
        instance.$router.push({
          name: "Meal Plan"
        });
      }
    } catch (e) {
      console.log(e);
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: var(--ion-color-primary) !important;
}
</style>
